import { odinClient } from "@/config/client"

export interface NextQuestionDiagnosticsMultipleChoise {
  index: number
  question: string
  questionType: "multiple_choice"
  options: string[]
  answer: string
}

export interface NextQuestionDiagnosticsOpenEnded {
  index: number
  question: string
  questionType: "open_ended"
  options: null
  answer: string
}

export interface NextQuestionDiagnosticAnalysis {
  index: number
  question: string
  questionType: "analysis"
  options: null
  answer: string
}

export type NextQuestionDiagnostics =
  | NextQuestionDiagnosticsMultipleChoise
  | NextQuestionDiagnosticsOpenEnded
  | NextQuestionDiagnosticAnalysis

export interface DiagnosticActivity {
  id: string
  next: NextQuestionDiagnostics
  total: number
  current: number
  more: boolean
}

export interface CreateStudySessionResponse {
  description: DiagnosticActivity
}

export interface Params {
  id: string
  body: { userActivityId: string }
}

export function create({ id, body }: Params) {
  return odinClient.post<CreateStudySessionResponse, Params["body"]>(
    `/v1/activities/${id}/diagnostics/study-session`,
    body,
  )
}
